import { Injectable } from '@angular/core';
import { SettingsService } from '../../../settings/settings.service';

@Injectable()
export class UserblockService {

    public userBlockVisible: boolean;

    constructor(private settings: SettingsService) {
        // initially visible
        this.userBlockVisible = true;
    }

    getUser() {
        return {
            name: this.settings.getUserSetting('prenom') ?
                    this.settings.getUserSetting('prenom') + ' ' + this.settings.getUserSetting('nom'):
                    this.settings.getUserSetting('nom'),
            role: this.settings.getUserSetting('user'),
        };
    }

    getVisibility() {
        return this.userBlockVisible;
    }

    setVisibility(stat = true) {
        this.userBlockVisible = stat;
    }

    toggleVisibility() {
        this.userBlockVisible = !this.userBlockVisible;
    }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/core/layout/sidebar/userblock/userblock.service.ts